import type { LayerType } from "@farm/domain/models/layer-type.model";
import type { FarmRepository } from "@farm/domain/repositories/farm.repository";
import { farmTypes } from "@farm/farm-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class LayerTypesGetAllUseCase {
    constructor(
        @inject(farmTypes.repositories.FarmRepository)
        private readonly farmRepository: FarmRepository,
    ) {}

    async execute(sources: string[]): Promise<LayerType[]> {
        return this.farmRepository.getLayerTypes(sources);
    }
}
